import { Stack } from '@mui/material';
import styled from 'styled-components';

const SearchFieldContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
`;

const ContentContainer = styled(Stack)`
  width: 100%;
  max-width: 720px;
`;

const SlackChannelContainer = styled.div`
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.palette.backdrop.main};
  }
  padding: ${({ theme }) => theme.spacing(1)};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
`;

export { SearchFieldContainer,
  SlackChannelContainer,
  PageContainer,
  ContentContainer };
